import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const giftCardApi = createAsyncThunk("giftCard", async () => {
  const response = await axiosInstance.get(`/giftcardget`);
  return response.data;
});

const giftCardSlice = createSlice({
  name: "giftCard",
  initialState: {
    giftCard: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(giftCardApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(giftCardApi.fulfilled, (state, action) => {
        state.giftCard = action.payload;
        state.loading = false;
      })
      .addCase(giftCardApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default giftCardSlice.reducer;
